import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../../../Helper/ToastMessage";


// Get Table Data
export const EquipmentMasterTableDataAPI = createAsyncThunk("EquipmentMasterTableData", async ({ data }) => {
    const {
        M_WardID,
        M_WTP_EquipmentTypeID,
        M_WTP_EquipmentMasterID,
        M_UserID,
        token,
        From,
        To,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/Master/Get_WEB_M_WTP_EquipmentMaster_Select?M_WardID=${M_WardID ? M_WardID : '0'}&M_WTP_EquipmentTypeID=${M_WTP_EquipmentTypeID ? M_WTP_EquipmentTypeID : '0'}&M_WTP_EquipmentMasterID=${M_WTP_EquipmentMasterID ? M_WTP_EquipmentMasterID : '0'}&M_UserID=${M_UserID}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            // console.log(result.data1, result.data) 
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data

            } else {
                return result
            }
        })
})

const EquipmentMasterTableDataSlice = createSlice({
    name: "EquipmentMasterTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(EquipmentMasterTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(EquipmentMasterTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(EquipmentMasterTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const EquipmentMasterTableDataReducer = EquipmentMasterTableDataSlice.reducer

export const EquipmentMasterTableExportDataAPI = createAsyncThunk("EquipmentMasterTableExportData", async ({ data }) => {
    const {
        M_WardID,
        M_WTP_EquipmentTypeID,
        M_WTP_EquipmentMasterID,
        M_UserID,
        token,
        From,
        To,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/Master/Get_WEB_M_WTP_EquipmentMaster_Select?M_WardID=${M_WardID ? M_WardID : '0'}&M_WTP_EquipmentTypeID=${M_WTP_EquipmentTypeID ? M_WTP_EquipmentTypeID : '0'}&M_WTP_EquipmentMasterID=${M_WTP_EquipmentMasterID ? M_WTP_EquipmentMasterID : '0'}&M_UserID=${M_UserID}&From=${From}&To=${To}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            // console.log(result.data1, result.data) 
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data

            } else {
                return result
            }
        })
})

const EquipmentMasterTableExportDataSlice = createSlice({
    name: "EquipmentMasterTableData",
    initialState: {
        isExportLoading: false,
        ExportTableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(EquipmentMasterTableExportDataAPI.pending, (state, action) => {
            state.isExportLoading = true;
        });
        builder.addCase(EquipmentMasterTableExportDataAPI.fulfilled, (state, action) => {
            state.isExportLoading = false;
            state.ExportTableData = action.payload;
        });
        builder.addCase(EquipmentMasterTableExportDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isExportLoading = false;
            state.isError = true;
            state.ExportTableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const EquipmentMasterTableExportDataReducer = EquipmentMasterTableExportDataSlice.reducer


export const EquipmentMasterPostDataAPI = createAsyncThunk("EquipmentMasterPostData", async ({ data }) => {
    const {
        M_WTP_EquipmentMasterID,
        M_WardID,
        M_WTP_EquipmentTypeID,
        EquipmentDetails,
        M_UserID,
        token,
        Flag,
        handleIsPost,
        handleClearField,
        handleOnCloseClick,
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("M_WTP_EquipmentMasterID",M_WTP_EquipmentMasterID);
    formdata.append("M_WardID", M_WardID);
    formdata.append("M_WTP_EquipmentTypeID", M_WTP_EquipmentTypeID);
    formdata.append("EquipmentDetails", EquipmentDetails);
    formdata.append("M_UserID", M_UserID);
    formdata.append("Flag", Flag);

    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    fetch(`${BaseUrl}/Master/Post_WEB_M_WTP_EquipmentMaster_InsertUpdate`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleIsPost()
                // handleClearField()
                handleOnCloseClick()
                toastSuccesss(result.message)
                return result.data
            } else {
                toastErrorr(result.message)
            }
            return result
        })
})

const EquipmentMasterPostDataSlice = createSlice({
    name: "EquipmentMasterPostData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(EquipmentMasterPostDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(EquipmentMasterPostDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(EquipmentMasterPostDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const EquipmentMasterPostDataReducer = EquipmentMasterPostDataSlice.reducer

// -----------------Delete API ---------------

export const EquipmentMasterDeleteAPI = createAsyncThunk("EquipmentMasterDelete", async ({ data }) => {
    const {
        M_WTP_EquipmentMasterID,
        M_UserID,
        token,
        handleIsPost
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);


    var formdata = new FormData();
    formdata.append("M_WTP_EquipmentMasterID", M_WTP_EquipmentMasterID);
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    fetch(`${BaseUrl}/Master/WEB_M_WTP_EquipmentMaster_Delete`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
                toastSuccesss(result.message)
            } else {
                toastErrorr(result.message)

            }
            return result

        })
})

const EquipmentMasterDeleteSlice = createSlice({
    name: "EquipmentMasterDelete",
    initialState: {
        isDeleteLoading: false,
        SectorData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(EquipmentMasterDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(EquipmentMasterDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.SectorData = action.payload;

        });
        builder.addCase(EquipmentMasterDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.SectorData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const EquipmentMasterDeleteReducer = EquipmentMasterDeleteSlice.reducer